<a class="subnav-list-item" [routerLink]="listItem.slug" routerLinkActive="active" [ngClass]="{'dark': darkMode}">
    <i [ngClass]="['fas', listItem.icon, 'subnav-list-item-icon']"></i>
    <div class="subnav-list-item-text">{{ listItem.name }}</div>
</a>